module.exports = __webpack_public_path__ + "static/media/solar-energy.9b985d2b.png";